export function getMandatoryCustomOptionsPrice (product) {
  if (!product || !product.custom_options) {
    return 0
  }
  return product.custom_options.reduce((total, option) => {
    const isMandatoryFixedOption = option.is_require &&
      option.type === 'checkbox' &&
      option.values &&
      option.values.length === 1
    if (isMandatoryFixedOption) {
      return total + (parseFloat(option.values[0].price) || 0)
    }
    return total
  }, 0)
}
